"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLayout = void 0;
const react_1 = __importStar(require("react"));
require("../../assets/css/styles.min.css");
const FThemeProvider_1 = require("../FthemeBuilder/FThemeProvider");
const ThemeBuilder_1 = require("../../shared/FthemeBuilder/ThemeBuilder");
const FLayout = ({ FsiderLayoutState = false, fontFamily = "primary", themeBuilder = true, className = "", children = undefined, }) => {
    const [themeConfig, setThemeConfig] = (0, react_1.useState)(ThemeBuilder_1.defaultThemeConfig);
    return themeBuilder ? (react_1.default.createElement(FThemeProvider_1.FThemeProvider, { themeConfig: themeConfig, setThemeConfig: setThemeConfig },
        react_1.default.createElement("div", { className: `f-layout f-layout-${FsiderLayoutState ? "shrink" : "expanded"} f-font-${fontFamily === "primary" ? fontFamily : fontFamily} ${className}` }, children))) : (react_1.default.createElement("div", { className: `f-layout ${`f-layout-${FsiderLayoutState ? "shrink" : "expanded"}`} ${className}` }, children));
};
exports.FLayout = FLayout;
//# sourceMappingURL=Flayout.js.map